import React from 'react';
import GeneralScience2023 from 'views/GeneralScience2023';

const AccountGeneralPage = () => {
  return <GeneralScience2023 />;
};

export default AccountGeneralPage;